import loadable from '@loadable/component';
import { WithLazyHydration } from '../../../WithLazyHydration';

const HamburgerMenuLoadable = loadable(() => import('./HamburgerMenu'), {
  resolveComponent: components => components.HamburgerMenu
});

export const HamburgerMenu = WithLazyHydration(HamburgerMenuLoadable, {
  name: 'HamburgerMenu'
});
